import tzdata from "tzdata";

export const TimeZones = Object.keys(tzdata.zones).map((zone) => ({
  label: zone,
  value: zone,
}));
